module.exports = __webpack_public_path__ + "static/media/misc.91ec9fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/home/images/misc.png
// module id = 533
// module chunks = 8